import type { FC } from 'react'
import { IconButton } from "@chakra-ui/react"
import { MdOutlineZoomIn } from "react-icons/md"

export const ImageFullScreenButton: FC<{url: string}> = ({url = '/fs/images/empty-image.png'}) => {
  return (
    <IconButton
      as='a' 
      href={url}
      colorScheme={'primary'}
      size={'sm'}
      variant={'outline'}
      aria-label='Open image in fullscreen mode.'
      icon={<MdOutlineZoomIn />}
    />
  )
}